import ActivityList from '../../../../components/activityList'
import ActivityMenu from '../../../../components/activityMenu'
import Alert from 'react-bootstrap/lib/Alert'
import Badge from '../../../../components/badge'
import BrandLogo from './brandLogo'
import Button from '../../../../components/button'
import Col from 'react-bootstrap/lib/Col'
import ColorSelector from '../../../../components/colorSelector'
import ComfortSlider from './comfortSlider'
import DesignCarousel from '../../../../components/designCarousel'
import Grid from '../../../../components/grid'
import Icon, {icons} from '../../../../components/icon'
import JsonLD from '../../../../components/jsonLD'
import LargeImgModal from '../../../../components/largeImgModal'
import Nav from 'react-bootstrap/lib/Nav'
import NavItem from 'react-bootstrap/lib/NavItem'
import OpenGraph from '../../../../components/openGraph'
import Panel from 'react-bootstrap/lib/Panel'
import Personalization from './personalization'
import ProductImage, {getImageQuery} from '../../../../components/productImage'
import ProductImageV2, {
  getImageQuery as getNewImageQuery
} from '../../../../components/productImageV2'
import ProductReviews, {REVIEWS_SORT} from './reviews'
import PropTypes from 'prop-types'
import PurchaseForm from './purchaseForm'
import React, {Component, Fragment} from 'react'
import RecommendationCarousel from '../../../../components/recommendationCarousel'
import Row from 'react-bootstrap/lib/Row'
import ServerContext from '../../../../components/serverContext'
import SizeFitSlider from './sizeFitSlider'
import Stars from '../../../../components/stars'
import StoreHeader from './header'
import Tab from 'react-bootstrap/lib/Tab'
import Table from 'react-bootstrap/lib/Table'
import Tabs from '../../../../components/tabs'
import Youtube from '../../../../components/youtube'
import debounce from 'lodash/debounce'
import filter from 'lodash/filter'
import find from 'lodash/find'
import flatMap from 'lodash/flatMap'
import flatMapDeep from 'lodash/flatMapDeep'
import get from 'lodash/get'
import last from 'lodash/last'
import pick from 'lodash/pick'
import some from 'lodash/some'
import sumBy from 'lodash/sumBy'
import isNil from 'lodash/isNil'
import {Formik, FormikEffect} from '../../../../components/formik'
import {TrackingConsumer} from '../../../../components/tracking'
import {bankersRounding} from '../../../../lib/helpers/currency'
import {applySizeSurcharge} from '../../../../lib/helpers/currency'
import {canonicalizeProduct} from '../../../../shared/canonicalize'
import {colors, text} from '../../../../styles'
import {connect} from 'react-redux'
import {
  createCartLineItem,
  deleteCartLineItem
} from '../../../../redux/actions/cart'
import {css} from 'glamor'
import {
  defaults,
  sizeToAbbreviationMappings
} from '../../../../constants/products'
import Cookies from 'js-cookie'
import {
  fetchActivities,
  fetchDesigns,
  fetchReviewsForProduct
} from '../../actions/api'
import {fetchAndValidateProduct} from '../validate'
import {fetchProductDesignsPreview} from '../../actions/productDetails'
import {filterAndSortProductOptions} from '../../../../shared/stores'
import {forceCheck} from 'react-lazyload'
import {generateRules, sanitizeColorName} from '../../../../shared/colors'
import {number, object, string} from 'yup'
import {
  productRecommendations,
  resetProductReviews,
  shoppingCartDetails
} from '../../actions'
import {speedDialActivityNames} from '../../../../constants/activities'

const productSkuToVideo = {
  '100-HS-M1': '5_rNQ1Xwzo4',
  '100-HS-W1': 'X98gR1-zGiw'
}

function getProductPADesigns(productPA) {
  return (
    productPA.Designs[`${productPA.Name} designs`] ||
    productPA.Designs[`${productPA.VName} designs`]
  )
}

const style = {
  activityHeader: css({
    marginTop: '20px',
    textTransform: 'none'
  }),
  activityName: css({
    color: colors.primaryBG
  }),
  brandLogo: css({
    marginBottom: '10px'
  }),
  colorSection: css({
    marginBottom: '20px',
    '@media (min-width: 768px)': {
      textAlign: 'center'
    }
  }),
  colorSelector: css({
    whiteSpace: 'nowrap',
    overflowX: 'scroll',
    padding: '2px 0 0 2px'
  }),
  descriptionTitle: css({
    textTransform: 'capitalize'
  }),
  designImage: css({
    '& img': {
      '@media (max-width: 991px)': {
        height: '101px',
        width: '126px'
      },
      '@media (min-width: 992px)': {
        height: '113px',
        width: '140px'
      }
    }
  }),
  detailBullet: css({
    marginLeft: '0',
    paddingLeft: '12px',
    position: 'relative',
    listStyle: 'none',
    '&::before': css(text.iconLarge, {
      color: colors.actionOrange,
      content: '\\2022',
      left: 0,
      marginRight: '6px',
      position: 'absolute',
      verticalAlign: 'middle'
    })
  }),
  detailBullets: css({
    marginLeft: '0',
    paddingLeft: '0',
    listStyle: 'none'
  }),
  featureShotModal: css({
    display: 'block',
    margin: 'auto'
  }),
  fitComfortCol: css({
    marginBottom: '20px'
  }),
  fitComfortRow: css({
    alignItems: 'center',
    marginBottom: '20px'
  }),
  magnifyIcon: css(text.iconLarge, {
    color: colors.gray46,
    left: 0,
    position: 'absolute',
    top: 0
  }),
  modalProductHeader: css({
    border: 'none'
  }),
  modalProductImage: css({
    textAlign: 'center'
  }),
  overlay: css({
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  }),
  pageHeader: css({
    borderBottom: 'none',
    marginBottom: '20px',
    marginTop: '10px',
    padding: 0,
    '& h1': {
      fontSize: '18px',
      lineHeight: '21px',
      margin: 0,
      textTransform: 'capitalize',
      '& small': {
        color: colors.grayMedium,
        display: 'block',
        fontSize: '14px',
        fontWeight: 'normal',
        lineHeight: '16px',
        textTransform: 'capitalize'
      }
    }
  }),
  panel: css({
    border: 'none',
    boxShadow: 'none',
    margin: '0 -15px'
  }),
  panelBody: css({
    borderBottom: `1px solid ${colors.lightBorder}`
  }),
  panelBodyDescription: css({
    borderBottom: `1px solid ${colors.lightBorder}`,
    '& p': text.small
  }),
  panelHeading: css({
    backgroundColor: `${colors.white} !important`,
    borderBottom: `1px solid ${colors.lightBorder} !important`,
    borderRadius: 0,
    padding: 0
  }),
  panelTitle: css(text.body, {
    lineHeight: '24px',
    '& > [role=button]': {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      padding: '10px 15px',
      textDecoration: 'none'
    },
    '& > [role=button][aria-expanded=true]': {
      backgroundColor: colors.grayLightest
    }
  }),
  panelSection: css({
    marginBottom: '40px',
    '& .panel:first-child .panel-heading': {
      borderTop: `1px solid ${colors.lightBorder}`
    }
  }),
  price: text.h3,
  priceHeader: css(text.bodySmall, {
    color: colors.grayMedium,
    marginBottom: '-2px',
    marginTop: 0
  }),
  productImage: css({
    color: colors.white,
    '@media (min-width: 320px)': {
      height: '480px',
      width: 'auto'
    }
  }),
  productImageReverse: css({
    '@media (min-width: 320px)': {
      height: '112px',
      width: '106px'
    }
  }),
  productImages: css({
    borderBottom: `1px solid ${colors.gray89}`,
    borderTop: `1px solid ${colors.gray89}`,
    padding: '1em',
    position: 'relative',
    '@media (min-width: 992px)': {
      border: `1px solid ${colors.gray89}`,
      margin: 0
    }
  }),
  productImageButton: css({
    background: 'none',
    border: 'none',
    display: 'inline-block',
    height: '100%',
    margin: 0,
    padding: 0,
    position: 'relative',
    width: '100%',
    '&:focus': {
      outline: 'none'
    }
  }),
  productPreview: css({
    background: 'none',
    border: 'none',
    bottom: '1em',
    margin: 0,
    padding: 0,
    position: 'absolute',
    right: '1em',
    '& > h5': css(text.bodySmallBold, {
      margin: '0',
      textTransform: 'uppercase',
      color: colors.gray46
    }),
    '& > span > img': {
      border: `1px solid ${colors.gray89}`,
      background: colors.white,
      padding: '8px 16px'
    }
  }),
  productTitle: css(text.bodyHeader, {
    textTransform: 'capitalize'
  }),
  ratingAverage: css(text.h4, {
    marginBottom: '5px',
    textTransform: 'none'
  }),
  ratingCount: css(text.h4, {
    marginBottom: '10px',
    textTransform: 'none'
  }),
  ratingRecommendationSummary: css(text.bodySmallBold, {
    marginBottom: '30px'
  }),
  ratingSummary: css({
    textAlign: 'center'
  }),
  get reviewsBody() {
    return css(style.panelBody, {
      borderBottom: 'none',
      paddingBottom: 0
    })
  },
  section: css({
    marginBottom: '20px'
  }),
  sectionHeader: css({
    lineHeight: '21px',
    marginBottom: '10px'
  }),
  selectedActivityButton: css({
    marginBottom: '15px !important'
  }),
  selectedActivity: css({
    color: colors.actionOrange
  }),
  starsAverage: css(text.icon, {
    fontSize: '18px',
    lineHeight: '18px'
  }),
  starsTitle: css(text.icon, {
    marginLeft: '40px',
    fontSize: '18px',
    lineHeight: '18px'
  }),
  toggleIcon: css({
    color: colors.grayMedium
  }),
  viewNavItem: css({
    textTransform: 'uppercase'
  }),
  viewTabs: css({
    '@media (max-width: 991px)': {
      margin: '0 -15px'
    }
  })
}
const AdminOrderChange = Cookies.get('AdminOrderChange')

const ColorDebug =
  process.env.NODE_ENV !== 'production'
    ? // eslint-disable-next-line
      ({rules, colors, expanded, onToggle}) => (
        <Panel expanded={expanded} {...style.panel} onToggle={onToggle}>
          <Panel.Heading {...style.panelHeading}>
            <Panel.Title toggle {...style.panelTitle}>
              Color Debugger
              <Icon
                icon={expanded ? icons.minus : icons.plus}
                {...style.toggleIcon}
              />
            </Panel.Title>
          </Panel.Heading>
          <Panel.Collapse>
            <Panel.Body>
              <div>
                {colors.map((c) => (
                  <div
                    key={c}
                    {...css({
                      background: `#${c}`,
                      width: '100px',
                      padding: '1px 6px'
                    })}>
                    <span {...css({color: `#${c}`, filter: 'invert(100%)'})}>
                      {c}
                    </span>
                  </div>
                ))}
              </div>
              <Table
                responsive
                striped
                {...css({
                  '& td': {
                    fontSize: '11px',
                    fontFamily:
                      'Menlo, Monaco, Consolas, "Courier New", monospace',
                    padding: '1px 6px !important',
                    textTransform: 'uppercase',
                    border: 'none !important'
                  },
                  '& td:first-child span, td:nth-child(2) span, td:nth-child(3) span':
                    {
                      filter: 'invert(100%)'
                    }
                })}>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Color1</th>
                    <th>Color2</th>
                    <th>School</th>
                    <th>Complementary</th>
                    <th>Brightness</th>
                    <th>Contrast</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    // Show debug info for the first two design colors, since that's
                    // all we currently generate.
                    // Make the number of columns variable if we ever support
                    // returning more than two.
                    rules.map((r, i) => (
                      <tr key={i}>
                        <td {...css({background: `#${r.productColor}`})}>
                          <span {...css({color: `#${r.productColor}`})}>
                            {r.productColor}
                          </span>
                        </td>
                        <td {...css({background: `#${r.designColors[0]}`})}>
                          <span {...css({color: `#${r.designColors[0]}`})}>
                            {r.designColors[0]}
                          </span>
                        </td>
                        <td {...css({background: `#${r.designColors[1]}`})}>
                          <span {...css({color: `#${r.designColors[1]}`})}>
                            {r.designColors[1]}
                          </span>
                        </td>
                        <td>{r.ranks.schoolColors}</td>
                        <td>{r.ranks.complementary}</td>
                        <td>{r.ranks.brightness}</td>
                        <td>{r.ranks.contrast}</td>
                        <td>{r.ranks.rank}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </Panel.Body>
          </Panel.Collapse>
        </Panel>
      )
    : () => null

class ProductDetails extends Component {
  static async initialize(props) {
    if (!(await fetchAndValidateProduct(props))) {
      return Promise.resolve()
    }

    const {dispatch, getState, location} = props
    const {schoolid, productid, editshoppingcartitem} = location.query
    const {
      newImageServer,
      product_designs: {items: productDesigns}
    } = getState()
    const {productMain: {ProductPA: designs = {}} = {}} = productDesigns
    return Promise.all([
      newImageServer
        ? dispatch(
            fetchDesigns(
              flatMapDeep(designs, (d) => Object.values(d.Designs)).map(
                (d) => d.id
              ),
              schoolid
            )
          )
        : Promise.resolve(),
      dispatch(
        productRecommendations.create({
          query: {storeid: schoolid, productid}
        })
      ),
      dispatch(
        fetchReviewsForProduct(schoolid, productid, '/byRating', {
          pageSize: 1,
          sort: 1
        })
      ),
      editshoppingcartitem
        ? dispatch(
            shoppingCartDetails.get({
              cached: true,
              options: {
                method: 'POST'
              }
            })
          )
        : Promise.resolve()
    ])
  }

  constructor(props) {
    super(props)
    // Default class year to next year if it's August or later
    const date = new Date()
    const classYear = (
      date.getFullYear() + (date.getMonth() >= 7 ? 1 : 0)
    ).toString()

    const {SelectedActivity} = props.productDesigns.productMain
    const activity = (props.location.query.activity || '').toUpperCase()

    this.state = {
      Personalization,
      classYear,
      playerName: '',
      playerNumber: '',

      // View logic
      currentViewName: this.defaultViewName(),
      errors: [],
      selectedActivityTag: speedDialActivityNames[activity]
        ? activity
        : SelectedActivity.Tag.toUpperCase(),
      selectedColorName: this.defaultProductOption(props).SanitizedColorName,
      selectedDesigns: this.defaultSelectedDesigns(),
      shouldShowDescription: false,
      shouldShowPopupImage: false,
      shouldShowFeatureShotModal: false,
      showActivityMenu: false,
      shouldShowColors: false,

      // Reviews
      reviewsSort: REVIEWS_SORT.NEWEST,
      shouldShowReviews: false
    }

    this.updatePersonalization = debounce(this.updatePersonalization, 500)
  }

  defaultProductOption(props) {
    const {
      storeDetails,
      product,
      productDesigns: {productMain}
    } = props
    const {Colors, SelectedColor} = productMain

    const productOptions = filterAndSortProductOptions(
      storeDetails,
      product.ProductOptions,
      Colors
    )

    return (
      find(productOptions, {
        SanitizedColorName: sanitizeColorName(SelectedColor.Name)
      }) || productOptions[0]
    )
  }

  defaultViewName() {
    return this.props.productDesigns.productMain.SelectedViewName
  }

  defaultSelectedDesigns() {
    return this.props.productDesigns.productMain.ProductPA.reduce(
      (designs, productPA) => ({
        ...designs,
        [productPA.Name]: {id: productPA.SelectedDesignId}
      }),
      {}
    )
  }

  componentDidMount() {
    const {
      media: {breakpoint}
    } = this.props

    if (breakpoint !== 'xs' && breakpoint !== 'sm') {
      this.loadReviews()
      this.setState({
        shouldShowReviews: true,
        shouldShowDescription: true,
        productImageV2Values: {}
      })
    }
  }

  UNSAFE_componentWillReceiveProps(props) {
    const {ProductID} = props.product
    if (ProductID !== this.props.product.ProductID) {
      this.setState({
        selectedColorName: this.defaultProductOption(props).SanitizedColorName
      })
    }
  }

  clearErrors = () => {
    this.setState({errors: []})
  }

  loadReviews = (queryParams, reset = true) => {
    const {reviewsSort: sort} = this.state

    let sortParams = {}
    if (sort === '1' || sort === '2') {
      sortParams = {sort}
    } else if (sort > 2) {
      sortParams = {rating: sort - 2}
    }

    if (reset) {
      this.props.dispatch(resetProductReviews())
    }

    this.props.dispatch(
      fetchReviewsForProduct(
        this.props.storeDetails.StoreID,
        this.props.product.ProductID,
        sort > 0 ? '/byRating' : '/byNewest',
        {...queryParams, ...sortParams}
      )
    )
  }

  onActivityListChange = (value) => {
    this.setState(
      {
        currentViewName: this.defaultViewName(),
        selectedActivityTag: value,
        selectedDesigns: this.defaultSelectedDesigns(),
        showActivityMenu: false
      },
      () => this.updateProductDesignsPreview()
    )
  }

  onDesignChange = (design) => {
    this.setState((state, props) => {
      const selectedView = find(props.productDesigns.productMain.Views, {
        Name: state.currentViewName
      })

      return {
        selectedDesigns: {
          ...state.selectedDesigns,
          [selectedView.PANames[0]]: {
            id: design?.id,
            cp: design?.cp
          }
        }
      }
    })
  }

  onFormChange = (
    {values: {classYear, playerName, playerNumber, Size}, sizes, setFieldValue},
    {
      values: {
        classYear: previousClassYear,
        playerName: previousPlayerName,
        playerNumber: previousPlayerNumber
      }
    }
  ) => {
    const size = find(sizes, {Name: Size})
    if (size && !size.Available) {
      setFieldValue('Size', null)
    }

    if (
      classYear !== previousClassYear ||
      playerName !== previousPlayerName ||
      playerNumber !== previousPlayerNumber
    ) {
      this.updatePersonalization({classYear, playerName, playerNumber}, true)
    }
  }

  onReviewsMore = () => {
    const lastReview = last(this.props.productReviews)
    this.loadReviews(
      {
        lastId: lastReview.ID,
        lastCreated: lastReview.RatingDate,
        lastRating: lastReview.StarRating
      },
      false
    )
  }

  onReviewsSort = (reviewsSort) => {
    this.setState(() => ({reviewsSort}), this.loadReviews)
  }

  onSelect = (name, value) => {
    this.setState({[name]: value}, forceCheck)
  }

  onColorSelect = (event) => {
    this.setState({selectedColorName: event.target.value}, () =>
      this.updateProductDesignsPreview()
    )
  }

  onSubmit = async (
    {CartLineItemImageUrl, Quantity, Size, Activity},
    {setSubmitting}
  ) => {
    const {
      dispatch,
      storeDetails,
      productDesigns: {
        productMain: {
          ClassYear: classYear,
          PlayerName: playerName,
          PlayerNumber: playerNumber,
          ProductID
        }
      },
      product
    } = this.props
    const {selectedColorName, selectedDesigns} = this.state

    const cartLineItem = this.getCartEditItem()
    // First delete cart item if this if an edit
    if (cartLineItem) {
      await dispatch(deleteCartLineItem(cartLineItem.LineItemID))
    }

    const Personalization = {
      playerName,
      playerNumber,
      classYear,
      ...pick(this.state, 'playerName', 'playerNumber', 'classYear')
    }

    return dispatch(
      createCartLineItem({
        Activity,
        Color: selectedColorName,
        Personalization,
        ProductID,
        ProductSize: Size,
        Price: product.PriceRegular,
        Quantity,
        SchoolID: storeDetails.StoreID,
        CartLineItemImageUrl,
        CartLineItemDesigns: Object.entries(selectedDesigns).map(
          ([PrintableArea, {id: DesignID}]) => ({
            PrintableArea,
            DesignID
          })
        )
      })
    )
      .then((resp) => {
        setSubmitting(false)

        if (resp.err) {
          const Value =
            (resp.err.body && resp.err.body.message) || 'Unable to connect'
          this.setState({errors: [{Value}]})
        } else if (resp.body && !resp.body.errors) {
          this.props.router.push('/cart')
        } else if (resp.body && resp.body.errors) {
          this.setState({errors: resp.body.errors})
        } else {
          this.setState({errors: [{Value: 'Unexpected response'}]})
        }
      })
      .catch(() => {
        setSubmitting(false)
        this.setState({errors: [{Value: 'Unexpected error'}]})
      })
  }

  updateProductDesignsPreview = () => {
    const {
      dispatch,
      newImageServer,
      productDesigns: {
        productMain: {ProductPA}
      },
      storeDetails
    } = this.props

    const {
      classYear,
      playerName,
      playerNumber,
      selectedActivityTag,
      selectedColorName,
      selectedDesigns
    } = this.state

    return Promise.all(
      ProductPA.map((productPA) =>
        dispatch(
          fetchProductDesignsPreview({
            personalization: {
              classYear: classYear || defaults.CLASS_YEAR,
              playerName: playerName || defaults.PLAYER_NAME,
              playerNumber: playerNumber || defaults.PLAYER_NUMBER
            },
            productPA,
            quantity: 1,
            selectedActivityTag,
            selectedColorName,
            selectedDesigns,
            selectedSize: 'S'
          })
        )
      )
    ).then((results) =>
      newImageServer
        ? dispatch(
            fetchDesigns(
              flatMapDeep(results, ({body: {PADesigns: designs} = {}}) =>
                Object.values(designs)
              ).map((d) => d.id),
              storeDetails.StoreID,
              selectedActivityTag
            )
          )
        : Promise.resolve()
    )
  }

  updatePersonalization({classYear, playerName, playerNumber}) {
    if (!/^\d{4}$/.test(classYear)) {
      return
    }

    this.setState({classYear, playerName, playerNumber}, () => {
      classYear = classYear || defaults.classYear
      playerName = playerName || defaults.playerName
      playerNumber = playerNumber || defaults.playerNumber
      // This cookie must be set before calls to add to cart are made since it
      // reads this cookie when validating the cart. The current staging prep
      // server sets this cookie on the wrong domain.
      document.cookie = `up_pp=${playerName}|${playerNumber}|${classYear}; path=/`
      this.updateProductDesignsPreview()
    })
  }

  toggleFeatureShotModal = () => {
    this.setState((state) => ({
      shouldShowFeatureShotModal: !state.shouldShowFeatureShotModal
    }))
  }

  togglePopupImage = () => {
    this.setState((state) => ({
      shouldShowPopupImage: !state.shouldShowPopupImage
    }))
  }

  toggleDescription = () => {
    this.setState((state) => ({
      shouldShowDescription: !state.shouldShowDescription
    }))
  }

  toggleReviews = () => {
    this.setState(
      (state) => ({
        shouldShowReviews: !state.shouldShowReviews
      }),
      () => {
        this.state.shouldShowReviews &&
          this.props.productReviews.length <= 1 &&
          this.loadReviews()
      }
    )
  }

  toggleColors = () => {
    this.setState((state) => ({
      shouldShowColors: !state.shouldShowColors
    }))
  }

  onToggleActivityMenu = () => {
    this.onViewAllActivities().then(() =>
      this.setState((state) => ({
        showActivityMenu: !state.showActivityMenu
      }))
    )
  }

  onViewAllActivities = () => {
    return this.props.dispatch(fetchActivities(this.props.storeDetails.StoreID))
  }

  hasNoReviews() {
    return this.props.product.RatingSummary.RatingCount === 0
  }

  getCartEditItem() {
    const {
      cartDetails,
      location: {
        query: {editshoppingcartitem: editShoppingCartItemId}
      }
    } = this.props

    let cartLineItem
    if (editShoppingCartItemId) {
      for (const cartItemGroup of cartDetails.CartItemGroups) {
        for (const cartItem of cartItemGroup.CartItems) {
          for (const element of cartItem.Elements) {
            if (element.LineItemID.toString() === editShoppingCartItemId) {
              cartLineItem = element
              break
            }
          }
        }
      }
    }

    return cartLineItem
  }

  render() {
    const {
      activities,
      designs,
      imageServerHost,
      location: {
        query: {productid}
      },
      media,
      newImageServer,
      serverHost,
      product,
      productDesigns: {
        productMain: {Colors, ProductPA, Views}
      },
      productRecommendations,
      productReviews,
      reviewCount,
      reviewsLoading,
      storeDetails
    } = this.props

    const {
      speedDialActivities,
      SchoolColor1: color1,
      SchoolColor2: color2,
      SchoolColor3: color3
    } = storeDetails

    const {
      Brand,
      Bullets,
      Description,
      MarketingUpsell,
      Overlay,
      ProductID,
      ProductName,
      RatingSummary,
      SchoolProductName,
      SizeChart,
      SKU
    } = product

    // This can happen when this component is about to unmount due to a route
    // change but its state is updated by initialization of a component in
    // a new route that share the same redux state.
    if (parseInt(productid, 10) !== ProductID || !product) {
      return null
    }

    const videoRef = productSkuToVideo[product.SKU]

    const {
      classYear,
      playerName,
      playerNumber,
      currentViewName,
      errors,
      reviewsSort,
      selectedActivityTag,
      selectedColorName,
      selectedDesigns,
      shouldShowDescription,
      shouldShowPopupImage,
      shouldShowFeatureShotModal,
      shouldShowReviews,
      shouldShowColors
    } = this.state

    const productOptions = filterAndSortProductOptions(
      storeDetails,
      product.ProductOptions,
      Colors
    )

    const selectedProductOption =
      find(productOptions, {SanitizedColorName: selectedColorName}) ||
      productOptions[0]

    const selectedProductMask =
      (product &&
        (product.ProductOptionViews || []).find(
          (pv) =>
            sanitizeColorName(pv.Color) === sanitizeColorName(selectedColorName)
        )) ||
      {}

    const {FitNote, PriceRegular} = product
    const editShoppingCartItem = this.getCartEditItem()

    const selectedActivity = find(
      flatMap(activities, (activity) => activity),
      {
        Tag: selectedActivityTag
      }
    ) ||
      speedDialActivities[0] || {Tag: selectedActivityTag}
    const selectedView = find(Views, {Name: currentViewName})
    const selectedProductPA = find(ProductPA, {
      Name: selectedView.PANames[0]
    })

    const selectedProductDesigns = getProductPADesigns(selectedProductPA)
    const selectedDesignIds = Object.values(selectedDesigns).map((sd) => sd.id)

    const productDesigns = flatMapDeep(ProductPA, (productPA) =>
      Object.values(productPA.Designs)
    )

    const filteredProductDesigns = filter(productDesigns, (design) =>
      selectedDesignIds.includes(design.id)
    )

    const selectedDesignFlags = {
      nb: some(filteredProductDesigns, ['nb', 1]),
      nm: some(filteredProductDesigns, ['nm', 1]),
      yr: some(filteredProductDesigns, ['yr', 1])
    }

    let reverseView
    let reverseProductPA

    if (Views.length === 2) {
      reverseView = find(Views, (view) => view.Name !== currentViewName)
      reverseProductPA = find(ProductPA, {
        Name: reverseView.PANames[0]
      })

      if (getProductPADesigns(reverseProductPA).length === 0) {
        reverseView = undefined
        reverseProductPA = undefined
      }
    }

    // Some products have an alternate view (FeatureShot), that has no designs
    // that should be shown
    let featureShot =
      !reverseView &&
      product.ProductOptionsFeatureShots.find(
        (fs) => fs.Color === selectedProductOption.Color
      )

    // Strip store name from product names
    const recommendedProducts = productRecommendations
      .filter((p) => p)
      .map((p) => ({
        ...p,
        Name: storeDetails
          ? p.Name.replace(storeDetails.StoreName, '').trim()
          : p.Name
      }))

    // Used for JSONLD below. We initially fetch the highest rated review which
    // is what Bots will see.
    const review = this.hasNoReviews() ? undefined : productReviews[0]
    const reviewerFirstName = get(review, 'User.FirstName', '')
    const reviewerLastName = get(review, 'User.LastName', '')

    const design = designs.find(
      (d) => d.DesignID === selectedDesigns[selectedProductPA.Name]?.id
    )

    const reverseDesignType =
      selectedProductPA.Name === 'Full Back' ? 'Full Front' : 'Full Back'

    const reverseDesign = designs.find(
      (d) => d.DesignID === selectedDesigns[reverseDesignType]?.id
    )

    const colors = [
      color1 && color1.ColorHexCode,
      color2 && color2.ColorHexCode,
      color3 && color3.ColorHexCode
    ].filter((c) => c)

    const rules = generateRules(
      selectedProductOption.ColorValue.ColorHexCode,
      colors,
      design
    )

    const reverseDesignRules = generateRules(
      selectedProductOption.ColorValue.ColorHexCode,
      colors,
      reverseDesign
    )
    const [selectedRule] = rules
    const [reverseSelectedRule] = reverseDesignRules

    const personalization = `${playerName || defaults.PLAYER_NAME}|${
      playerNumber || defaults.PLAYER_NUMBER
    }|${classYear || defaults.CLASS_YEAR}`

    const mobileActivityMenu = speedDialActivities.length > 0 && (
      <Row>
        <Col xs={12} mdHidden lgHidden>
          <Button
            kind="stroke"
            onClick={this.onToggleActivityMenu}
            size="block"
            {...style.selectedActivityButton}>
            Activity:{' '}
            <span {...style.selectedActivity}>{selectedActivity.Name}</span>
          </Button>
          <ActivityMenu
            activities={activities}
            onChange={this.onActivityListChange}
            onHide={this.onToggleActivityMenu}
            schoolType={storeDetails.SchoolTypes[0]}
            show={this.state.showActivityMenu}
            speedDialActivities={speedDialActivities}
            value={selectedActivity}
          />
        </Col>
      </Row>
    )

    return (
      <ServerContext.Consumer>
        {(value) => {
          const {IMAGE_SERVER_HOST, SERVER_HOST} = value.hosts
          const canonicalUrl = `${SERVER_HOST}${canonicalizeProduct(
            storeDetails,
            product
          )}`

          const canonicalImage = `${IMAGE_SERVER_HOST}/GetImage.iaspx?${getImageQuery(
            {
              activity: selectedActivity.Tag,
              design: selectedDesigns[selectedProductPA.Name]?.id,
              personalization,
              productId: ProductID,
              productColor: selectedProductOption.SanitizedColorName,
              storeId: storeDetails.StoreID,
              side: selectedView.Name[0],
              ver: storeDetails.StoreVersion
            }
          )}`

          const featureShotImage =
            featureShot &&
            `${IMAGE_SERVER_HOST}/productimages/${product.SKU}/FeatureShot_${selectedProductOption.SanitizedColorName}_${featureShot.PhotoStorageFeatureTypes[0].TypeName}.png`

          return (
            <Fragment>
              <OpenGraph
                head={{
                  ...product,
                  PageTitle: `${storeDetails.StoreName} ${ProductName}`,
                  CanonicalUrl: canonicalUrl,
                  OGImage: canonicalImage
                }}
              />
              <JsonLD
                data={{
                  '@type': 'Product',
                  name: `${storeDetails.SchoolName} ${ProductName}`,
                  description: Description,
                  mpn: ProductID,
                  sku: SKU,
                  image: canonicalImage,
                  brand: {
                    '@type': 'Thing',
                    name: Brand
                  },
                  offers: {
                    '@type': 'Offer',
                    priceCurrency: 'USD',
                    price: PriceRegular,
                    itemCondition: 'http://schema.org/NewCondition',
                    availability: 'http://schema.org/InStock',
                    url: canonicalUrl
                  },
                  aggregateRating: {
                    '@type': 'AggregateRating',
                    ratingValue: RatingSummary.AverageStarRating,
                    reviewCount: RatingSummary.RatingCount
                  },
                  review: review && {
                    '@type': 'Review',
                    reviewRating: {
                      '@type': 'Rating',
                      ratingValue: review.StarRating,
                      bestRating: 5
                    },
                    reviewBody: review.TextReview,
                    author: {
                      '@type': 'Person',
                      name: `${reviewerFirstName} ${reviewerLastName}`
                    }
                  }
                }}
              />
              <LargeImgModal
                onClose={this.togglePopupImage}
                show={shouldShowPopupImage}>
                {newImageServer ? (
                  <ProductImageV2
                    activity={selectedActivity.Name}
                    colors={selectedRule.designColors}
                    negative={selectedRule.negative}
                    design={design}
                    imageHost={newImageServer}
                    height={624}
                    personalization={{
                      playerName: playerName || defaults.PLAYER_NAME,
                      playerNumber: playerNumber || defaults.PLAYER_NUMBER,
                      classYear: classYear || defaults.CLASS_YEAR
                    }}
                    productColor={selectedProductOption.SanitizedColorName}
                    maskColor={selectedProductMask.ParentColor}
                    productId={ProductID}
                    responsive
                    store={storeDetails}
                    view={currentViewName}
                  />
                ) : (
                  <ProductImage
                    activity={selectedActivity.Tag}
                    design={selectedDesigns[selectedProductPA.Name]?.id}
                    imageHost={IMAGE_SERVER_HOST}
                    outputFormat="png"
                    personalization={personalization}
                    productId={ProductID}
                    productColor={selectedProductOption.SanitizedColorName}
                    responsive
                    scale={120}
                    storeId={storeDetails.StoreID}
                    side={selectedView.Name[0]}
                    type={1}
                    ver={storeDetails.StoreVersion}
                  />
                )}
              </LargeImgModal>

              <Grid>
                <StoreHeader
                  product={product}
                  store={storeDetails}
                  isCorrectionAllowed={storeDetails.IsCorrectionAllowed}
                  isEditAllowed={storeDetails.IsEditAllowed}
                />
                <Row>
                  <Col xs={12} sm={12} md={6} lg={7}>
                    <div className="productImage" {...style.section}>
                      <h2 {...style.productTitle}>{ProductName}</h2>
                      <Tabs
                        activeKey={currentViewName}
                        id="productViews"
                        onSelect={(key) =>
                          this.onSelect('currentViewName', key)
                        }
                        {...style.viewTabs}>
                        <div>
                          <Tab.Content
                            animation={false}
                            {...style.productImages}>
                            {Views.map((view) => (
                              <Tab.Pane
                                key={`productImage-${view.Name}`}
                                eventKey={view.Name}>
                                <button
                                  onClick={this.togglePopupImage}
                                  {...style.productImageButton}>
                                  <Icon
                                    icon={icons.searchPlus}
                                    {...style.magnifyIcon}
                                  />
                                  {newImageServer ? (
                                    <ProductImageV2
                                      activity={selectedActivity.Name}
                                      colors={selectedRule.designColors}
                                      negative={selectedRule.negative}
                                      design={designs.find(
                                        (d) =>
                                          d.DesignID ===
                                          selectedDesigns[
                                            selectedProductPA.Name
                                          ]?.id
                                      )}
                                      imageHost={newImageServer}
                                      height={480}
                                      personalization={{
                                        playerName:
                                          playerName || defaults.PLAYER_NAME,
                                        playerNumber:
                                          playerNumber ||
                                          defaults.PLAYER_NUMBER,
                                        classYear:
                                          classYear || defaults.CLASS_YEAR
                                      }}
                                      productColor={
                                        selectedProductOption.SanitizedColorName
                                      }
                                      maskColor={
                                        selectedProductMask.ParentColor
                                      }
                                      productId={ProductID}
                                      responsive
                                      store={storeDetails}
                                      style={style.productImage}
                                      view={currentViewName}
                                    />
                                  ) : (
                                    <ProductImage
                                      activity={selectedActivity.Tag}
                                      className={`productImage-${view.Name}`}
                                      design={
                                        selectedDesigns[selectedProductPA.Name]
                                          .id
                                      }
                                      imageHost={IMAGE_SERVER_HOST}
                                      outputFormat="png"
                                      personalization={personalization}
                                      productId={ProductID}
                                      productColor={
                                        selectedProductOption.SanitizedColorName
                                      }
                                      responsive
                                      scale={92.4}
                                      storeId={storeDetails.StoreID}
                                      side={view.Name.charAt(0)}
                                      style={style.productImage}
                                      type={1}
                                      ver={storeDetails.StoreVersion}
                                      {...style.productImage}
                                    />
                                  )}
                                  {Overlay ? (
                                    <div
                                      {...css(style.overlay, {
                                        backgroundImage: `url(${IMAGE_SERVER_HOST}/productimages/promos/${Overlay})`
                                      })}
                                    />
                                  ) : null}
                                </button>
                                {featureShot && (
                                  <button
                                    onClick={this.toggleFeatureShotModal}
                                    {...style.productPreview}>
                                    <h5>Back</h5>
                                    <span>
                                      <img
                                        src={featureShotImage}
                                        {...style.productImageReverse}
                                      />
                                    </span>
                                  </button>
                                )}
                                {reverseView && (
                                  <button
                                    onClick={() =>
                                      this.onSelect(
                                        'currentViewName',
                                        reverseView.Name
                                      )
                                    }
                                    {...style.productPreview}>
                                    <h5>{reverseView.Name}</h5>
                                    {newImageServer ? (
                                      <ProductImageV2
                                        activity={selectedActivity.Name}
                                        colors={
                                          reverseSelectedRule.designColors
                                        }
                                        negative={reverseSelectedRule.negative}
                                        design={designs.find(
                                          (d) =>
                                            d.DesignID ===
                                            selectedDesigns[
                                              reverseProductPA.Name
                                            ]?.id
                                        )}
                                        imageHost={newImageServer}
                                        height={94}
                                        personalization={{
                                          playerName:
                                            playerName || defaults.PLAYER_NAME,
                                          playerNumber:
                                            playerNumber ||
                                            defaults.PLAYER_NUMBER,
                                          classYear:
                                            classYear || defaults.CLASS_YEAR
                                        }}
                                        productColor={
                                          selectedProductOption.SanitizedColorName
                                        }
                                        maskColor={
                                          selectedProductMask.ParentColor
                                        }
                                        productId={ProductID}
                                        responsive
                                        store={storeDetails}
                                        style={style.productImageReverse}
                                        view={reverseView.Name}
                                      />
                                    ) : (
                                      <ProductImage
                                        activity={selectedActivity.Tag}
                                        design={
                                          selectedDesigns[reverseProductPA.Name]
                                            ?.id
                                        }
                                        imageHost={IMAGE_SERVER_HOST}
                                        outputFormat="png"
                                        personalization={personalization}
                                        productId={ProductID}
                                        productColor={
                                          selectedProductOption.SanitizedColorName
                                        }
                                        responsive
                                        scale={18}
                                        storeId={storeDetails.StoreID}
                                        side={reverseView.Name.charAt(0)}
                                        style={style.productImageReverse}
                                        type={1}
                                        ver={storeDetails.StoreVersion}
                                      />
                                    )}
                                  </button>
                                )}
                              </Tab.Pane>
                            ))}
                          </Tab.Content>
                          {Views.length > 1 && reverseView !== undefined ? (
                            <Nav bsStyle="tabs">
                              {Views.map((view) => (
                                <NavItem
                                  key={`views-${view.Name}`}
                                  eventKey={view.Name}
                                  {...style.viewNavItem}>
                                  {view.Name} Design
                                </NavItem>
                              ))}
                            </Nav>
                          ) : null}
                        </div>
                      </Tabs>
                    </div>
                    <div {...style.colorSection}>
                      <h5 className="selectedColor" {...style.sectionHeader}>
                        {selectedProductOption.SanitizedColorName
                          ? `Color: ${selectedProductOption.Color}`
                          : 'Choose a Color'}
                      </h5>
                      <ColorSelector
                        imageServerHost={imageServerHost}
                        options={productOptions}
                        onChange={this.onColorSelect}
                        value={selectedProductOption.SanitizedColorName}
                        storageObjects={this.props.storageObjects}
                        newImageServer={this.props.newImageServer}
                      />
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={6} lg={5}>
                    <Row>
                      {speedDialActivities.length > 0 && (
                        <Col xsHidden smHidden md={12}>
                          <h5 {...style.activityHeader}>
                            Activities:{' '}
                            <span
                              className="selectedActivity"
                              {...style.activityName}>
                              {selectedActivity.Name}
                            </span>
                          </h5>
                          <ActivityList
                            activities={activities}
                            speedDialActivities={speedDialActivities}
                            schoolType={storeDetails.SchoolTypes[0]}
                            onChange={this.onActivityListChange}
                            onViewAll={this.onViewAllActivities}
                            value={selectedActivity}
                          />
                        </Col>
                      )}
                      <Col xs={12}>
                        <h5 {...style.sectionHeader}>Choose Design</h5>
                        <TrackingConsumer>
                          {(push) => (
                            <DesignCarousel
                              designs={selectedProductDesigns}
                              name="DesignId"
                              onChange={(design, index) => {
                                push({
                                  action: 'click',
                                  design: design?.id,
                                  index,
                                  product: ProductID
                                })

                                this.onDesignChange(design)
                              }}
                              selectedDesign={
                                selectedDesigns[selectedProductPA.Name]?.id
                              }>
                              {(design) => {
                                if (newImageServer) {
                                  const designData = designs.find(
                                    (d) => d.DesignID === design?.id
                                  )
                                  if (!designData) {
                                    return null
                                  }

                                  const [rule] = generateRules(
                                    selectedProductOption.ColorValue
                                      .ColorHexCode,
                                    colors,
                                    designData
                                  )

                                  if (!rule) {
                                    return
                                  }

                                  return (
                                    <ProductImageV2
                                      activity={selectedActivity.Name}
                                      bgColor={rule.productColor}
                                      colors={rule.designColors}
                                      negative={rule.negative}
                                      data-design={designData.DesignID}
                                      design={designData}
                                      imageHost={newImageServer}
                                      personalization={{
                                        playerName:
                                          playerName || defaults.PLAYER_NAME,
                                        playerNumber:
                                          playerNumber ||
                                          defaults.PLAYER_NUMBER,
                                        classYear:
                                          classYear || defaults.CLASS_YEAR
                                      }}
                                      productColor={
                                        selectedProductOption.SanitizedColorName
                                      }
                                      maskColor={
                                        selectedProductMask.ParentColor
                                      }
                                      productId={ProductID}
                                      store={storeDetails}
                                      style={style.designImage}
                                      type="design"
                                      view={currentViewName}
                                    />
                                  )
                                } else {
                                  return (
                                    <ProductImage
                                      activity={selectedActivity.Tag}
                                      data-design={design?.id}
                                      design={design?.id}
                                      imageHost={IMAGE_SERVER_HOST}
                                      productId={ProductID}
                                      scale={design.scale}
                                      storeId={storeDetails.StoreID}
                                      style={style.designImage}
                                      sku={SKU}
                                      type={2}
                                      ver={storeDetails.StoreVersion}
                                      personalization={personalization}
                                    />
                                  )
                                }
                              }}
                            </DesignCarousel>
                          )}
                        </TrackingConsumer>
                      </Col>
                    </Row>
                    <Formik
                      initialValues={{
                        classYear: classYear,
                        playerName: '',
                        playerNumber: '',
                        Quantity: 1,
                        Size: editShoppingCartItem
                          ? sizeToAbbreviationMappings[
                              editShoppingCartItem.Size
                            ]
                          : productOptions[0].Sizes.length === 1
                          ? productOptions[0].Sizes[0].Name
                          : null,
                        cartLineItemImageUrl: ''
                      }}
                      onSubmit={(values, options) => {
                        // Creating cart items directly requires the size long name

                        let selectedSize = ''
                        if (values.Size.toLowerCase() === 'one size') {
                          selectedSize = 'one size'
                        } else {
                          let sizeObj = find(selectedProductOption.Sizes, {
                            Name: values.Size
                          })
                          selectedSize = sizeObj.LongName
                        }
                        //This function determines how to get the CartLienItemImageUrl
                        //If the user has a back design selected it will force return the front design url
                        //So that when they navigate to the cart, it saves the front design image and not the back.
                        const getCartLineItemImageUrl = () => {
                          let productImageValues = {}
                          if (
                            selectedProductPA.Name === 'Full Front' ||
                            selectedProductPA.Name === 'Left Chest'
                          ) {
                            productImageValues = {
                              activity: selectedActivity.Name,
                              colors: selectedRule.designColors,
                              negative: selectedRule.negative,
                              design: design,
                              imageHost: newImageServer,
                              height: 624,
                              personalization: personalization,
                              productColor:
                                selectedProductOption.SanitizedColorName,
                              maskColor: selectedProductMask.ParentColor,
                              productId: ProductID,
                              store: storeDetails,
                              view: currentViewName
                            }
                          } else if (selectedProductPA.Name === 'Full Back') {
                            productImageValues = {
                              activity: selectedActivity.Name,
                              colors: reverseSelectedRule.designColors,
                              negative: reverseSelectedRule.negative,
                              design: reverseDesign,
                              imageHost: newImageServer,
                              height: 624,
                              personalization: personalization,
                              productColor:
                                selectedProductOption.SanitizedColorName,
                              maskColor: selectedProductMask.ParentColor,
                              productId: ProductID,
                              store: storeDetails,
                              view: 'Front'
                            }
                          }

                          const query = newImageServer
                            ? getNewImageQuery(productImageValues)
                            : ''
                          return newImageServer
                            ? `${newImageServer}/pi?${query}`
                            : ''
                        }

                        this.onSubmit(
                          {
                            ...values,
                            CartLineItemImageUrl: getCartLineItemImageUrl(),
                            Size: selectedSize,
                            SelectedRule: selectedRule,
                            Activity: selectedActivity
                          },
                          options
                        )
                      }}
                      render={(props) => {
                        let {PriceRegular} = product
                        let salePrice

                        const {Sizes: sizes} = selectedProductOption
                        const selectedSize = find(sizes, {
                          Name: props.values.Size
                        })

                        const calculateSalePriceWithPromo = (Promo) => {
                          let salePrice
                          if (Promo) {
                            salePrice =
                              PriceRegular * (1 - Promo.DiscountValue / 100)
                          }
                          return salePrice
                        }

                        if (selectedSize?.Surcharge) {
                          PriceRegular = applySizeSurcharge(
                            PriceRegular,
                            selectedSize?.Surcharge || 0
                          )
                        }
                        if (product.Promo) {
                          salePrice = calculateSalePriceWithPromo(product.Promo)
                        }
                        const selectedDesignsOnState = Object.values(
                          this.state.selectedDesigns
                        )

                        if (selectedDesignsOnState.length > 0) {
                          const toAdd =
                            sumBy(
                              selectedDesignsOnState.filter(
                                (sd) => !isNil(sd.cp)
                              ),
                              'cp'
                            ) || 0
                          PriceRegular += parseFloat(toAdd)
                          salePrice = calculateSalePriceWithPromo(product.Promo)
                        }

                        return (
                          <Fragment>
                            <FormikEffect
                              onChange={this.onFormChange}
                              setFieldValue={props.setFieldValue}
                              sizes={sizes}
                              values={props.values}
                            />
                            {selectedDesignFlags ? (
                              <Personalization
                                selectedDesignFlags={selectedDesignFlags}
                                {...props}
                              />
                            ) : null}
                            {mobileActivityMenu}
                            <PurchaseForm
                              AdminOrderChange={AdminOrderChange}
                              cta={
                                editShoppingCartItem
                                  ? 'Update Cart'
                                  : 'Add to Cart'
                              }
                              fitNote={FitNote}
                              price={bankersRounding(PriceRegular)}
                              salePrice={bankersRounding(salePrice)}
                              sizeChart={SizeChart}
                              sizes={selectedProductOption.Sizes}
                              {...props}
                            />
                            {errors.length > 0 ? (
                              <Alert
                                bsStyle="danger"
                                onDismiss={this.clearErrors}>
                                <h5>Whoops!</h5>
                                <p>
                                  We seem to have run into some problems;
                                  perhaps try again?
                                </p>
                                <ul>
                                  {errors.map((item, index) => (
                                    <li key={index}>{item.Value}</li>
                                  ))}
                                </ul>
                              </Alert>
                            ) : null}
                          </Fragment>
                        )
                      }}
                      validationSchema={object().shape({
                        classYear: string().when('$other', {
                          is: () => {
                            return selectedDesignFlags.yr
                          },
                          then: string()
                            .test(
                              'is-four-digits',
                              'Year should be four digits',
                              (value) => /^\d{4}$/.test(value)
                            )
                            .required('Year is required'),
                          otherwise: string().nullable()
                        }),
                        playerName: string().when('$other', {
                          is: () => selectedDesignFlags.nm,
                          then: string().required('Player name is required'),
                          otherwise: string().nullable()
                        }),
                        playerNumber: string().when('$other', {
                          is: () => selectedDesignFlags.nb,
                          then: string()
                            .test(
                              'is-two-digits',
                              'Player number should be 1 or 2 digits',
                              (value) => /^\d{1,2}$/.test(value)
                            )
                            .required('Player number required'),
                          otherwise: string().nullable()
                        }),
                        Quantity: number().required(),
                        Size: string().nullable().required()
                      })}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm={12}>
                    <div {...style.panelSection}>
                      {newImageServer && rules && rules[0].ranks && (
                        <ColorDebug
                          expanded={shouldShowColors}
                          onToggle={this.toggleColors}
                          rules={rules}
                          colors={colors}
                        />
                      )}
                      <Panel
                        expanded={shouldShowDescription}
                        onToggle={this.toggleDescription}
                        {...style.panel}>
                        <Panel.Heading {...style.panelHeading}>
                          <Panel.Title toggle {...style.panelTitle}>
                            Product Description &amp; Details
                            <Icon
                              icon={
                                shouldShowDescription ? icons.minus : icons.plus
                              }
                              {...style.toggleIcon}
                            />
                          </Panel.Title>
                        </Panel.Heading>
                        <Panel.Collapse>
                          <Panel.Body {...style.panelBodyDescription}>
                            <h5 {...style.sectionHeader}>
                              Product Description
                            </h5>
                            <Row>
                              <Col xs={12} md={videoRef ? 6 : 12}>
                                <div {...style.brandLogo}>
                                  <BrandLogo
                                    serverHost={serverHost}
                                    brand={Brand}
                                  />
                                </div>
                                {MarketingUpsell.Enable && (
                                  <Badge type={MarketingUpsell.Type}>
                                    {MarketingUpsell.Label}
                                  </Badge>
                                )}
                                <h5 {...style.descriptionTitle}>
                                  {SchoolProductName} ({SKU}) - ${PriceRegular}
                                </h5>
                                <p>{Description}</p>
                                <h5 {...style.sectionHeader}>
                                  Product Details
                                </h5>
                                <ul {...style.detailBullets}>
                                  {Bullets.map((bullet) => (
                                    <li key={bullet} {...style.detailBullet}>
                                      {bullet}
                                    </li>
                                  ))}
                                </ul>
                              </Col>
                              {videoRef && (
                                <Col xs={12} md={6}>
                                  <Youtube videoRef={videoRef} />
                                </Col>
                              )}
                            </Row>
                          </Panel.Body>
                        </Panel.Collapse>
                      </Panel>
                      <Panel
                        expanded={shouldShowReviews}
                        onToggle={this.toggleReviews}
                        {...style.panel}>
                        <Panel.Heading {...style.panelHeading}>
                          <Panel.Title toggle {...style.panelTitle}>
                            <span>
                              Product Reviews
                              <Stars
                                rating={RatingSummary.AverageStarRating}
                                style={style.starsTitle}
                              />
                            </span>
                            <Icon
                              icon={
                                shouldShowReviews ? icons.minus : icons.plus
                              }
                              {...style.toggleIcon}
                            />
                          </Panel.Title>
                        </Panel.Heading>
                        <Panel.Collapse>
                          <Panel.Body {...style.reviewsBody}>
                            <h5 {...style.sectionHeader}>Product Review</h5>
                            <div {...style.ratingSummary}>
                              <div {...style.ratingAverage}>
                                <Stars
                                  rating={RatingSummary.AverageStarRating}
                                  style={style.starsAverage}
                                />{' '}
                                {!this.hasNoReviews() &&
                                  RatingSummary.AverageStarRating}
                              </div>
                              <div {...style.ratingCount}>
                                {RatingSummary.RatingCount} Reviews
                              </div>
                              {!this.hasNoReviews() ? (
                                <Fragment>
                                  <div {...style.ratingRecommendationSummary}>
                                    {RatingSummary.AverageWouldRecommendRating}%
                                    of reviewers recommend this product
                                  </div>
                                  <Row {...style.fitComfortRow}>
                                    <Col
                                      xs={12}
                                      sm={6}
                                      md={3}
                                      mdPush={3}
                                      {...style.fitComfortCol}>
                                      <SizeFitSlider
                                        value={
                                          RatingSummary.AverageOverallFitRating
                                        }
                                      />
                                    </Col>
                                    <Col
                                      xs={12}
                                      sm={6}
                                      md={3}
                                      mdPush={3}
                                      {...style.fitComfortCol}>
                                      <ComfortSlider
                                        value={
                                          RatingSummary.AverageComfortRating
                                        }
                                      />
                                    </Col>
                                  </Row>
                                </Fragment>
                              ) : null}
                            </div>
                            <ProductReviews
                              totalCount={reviewCount}
                              loading={reviewsLoading}
                              onSort={this.onReviewsSort}
                              onMore={this.onReviewsMore}
                              reviews={productReviews}
                              sort={reviewsSort}
                            />
                          </Panel.Body>
                        </Panel.Collapse>
                      </Panel>
                    </div>
                    {recommendedProducts.length ? (
                      <div className="related">
                        <h5 {...style.sectionHeader}>You Might Also Like</h5>
                        <RecommendationCarousel
                          breakpoint={media.breakpoint}
                          imageHost={IMAGE_SERVER_HOST}
                          productRecommendations={recommendedProducts}
                          store={storeDetails}
                        />
                      </div>
                    ) : null}
                  </Col>
                </Row>
              </Grid>
            </Fragment>
          )
        }}
      </ServerContext.Consumer>
    )
  }
}

ProductDetails.displayName = 'ProductDetails'

ProductDetails.propTypes = {
  activities: PropTypes.object,
  cartDetails: PropTypes.object,
  designs: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  imageServerHost: PropTypes.string,
  location: PropTypes.object.isRequired,
  media: PropTypes.shape({
    breakpoint: PropTypes.string.isRequired
  }).isRequired,
  newImageServer: PropTypes.string,
  product: PropTypes.object,
  productDesigns: PropTypes.PropTypes.object.isRequired,
  productRecommendations: PropTypes.array.isRequired,
  productReviews: PropTypes.array,
  reviewCount: PropTypes.number,
  reviewsLoading: PropTypes.bool,
  router: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  storeDetails: PropTypes.object.isRequired,
  serverHost: PropTypes.string
}

const stateToProps = (state) => {
  const {
    activities: {items: activities},
    cart_details: {
      items: {model: cartDetails}
    },
    designs: {items: designs},
    error,
    hosts: {IMAGE_SERVER_HOST: imageServerHost, SERVER_HOST: serverHost},
    media,
    newImageServer,
    product_designs: {items: productDesigns},
    product_recommendations: {items: productRecommendations},
    product_reviews: {
      items: productReviews,
      loading: reviewsLoading,
      count: reviewCount
    },
    store_products: {items: product},
    stores: {
      items: [storeDetails]
    },
    storageObjects
  } = state

  return {
    activities: Object.keys(activities).length
      ? activities
      : storeDetails.activities,
    cartDetails,
    designs,
    error,
    imageServerHost,
    media,
    newImageServer,
    product,
    productDesigns,
    productRecommendations,
    productReviews,
    reviewCount,
    reviewsLoading,
    serverHost,
    storeDetails,
    storageObjects
  }
}

export default connect(stateToProps)(ProductDetails)
